// Tiny debounce hook — returns `value` only after it has stopped changing for
// `delay` ms. Used to throttle the exercise/location search queries so we don't
// fire a request on every keystroke.
import { useEffect, useState } from "react";

export function useDebounced<T>(value: T, delay = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
